import React from "react";
import AdminPage from "../AdminPage";
import useAdminList from "../useAdminList";
import InvestorsData from "../InvestorsData/InvestorsData";

const COPY = {
  title: "Investors Requests",
  subtitle: "You Can See & Edit Detail About Investors",
  searchPlaceholder: "Search Here",
};

const InvestorsAdmin = () => {
  const { items, loading, searchValue, setSearchValue } = useAdminList(
    "getUsers",
    "fullName"
  );

  return (
    <AdminPage
      title={COPY.title}
      subtitle={COPY.subtitle}
      loading={loading}
      search={{
        value: searchValue,
        onChange: setSearchValue,
        placeholder: COPY.searchPlaceholder,
      }}
    >
      <InvestorsData driverData={items} />
    </AdminPage>
  );
};

export default InvestorsAdmin;
